import { render, staticRenderFns } from "./RequestTypeForm.vue?vue&type=template&id=1137d984&scoped=true&"
import script from "./RequestTypeForm.vue?vue&type=script&lang=js&"
export * from "./RequestTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestTypeForm.vue?vue&type=style&index=0&id=1137d984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1137d984",
  null
  
)

export default component.exports